const firebaseErrorMessages = {
    'auth/app-deleted': 'The authentication object has been deleted.',
    'auth/app-not-authorized': 'The app is not authorized to use Authentication.',
    'auth/argument-error': 'An invalid argument was provided to a Authentication method.',
    'auth/invalid-api-key': 'The provided API key is invalid.',
    'auth/invalid-user-token': 'The user\'s token is no longer valid.',
    'auth/network-request-failed': 'A network error occurred when trying to make a request.',
    'auth/operation-not-allowed': 'The type of account corresponding to this credential is not enabled.',
    'auth/requires-recent-login': 'This operation is sensitive and requires recent authentication.',
    'auth/too-many-requests': 'Too many requests were made. Please try again.',
    'auth/unauthorized-domain': 'The app domain is not authorized for OAuth operations.',
    'auth/user-disabled': 'The user account has been disabled by an administrator.',
    'auth/user-token-expired': 'The user\'s token has expired.',
    'auth/web-storage-unsupported': 'This browser is not supported or 3rd party cookies and data may be disabled.',
    'auth/account-exists-with-different-credential': 'An account already exists with the same email address but different sign-in credentials.',
    'auth/credential-already-in-use': 'This credential is already associated with a different user account.',
    'auth/email-already-in-use': 'The email address is already in use by another account.',
    'auth/internal-error': 'An internal error has occurred.',
    'auth/invalid-credential': 'The supplied auth credential is malformed or has expired.',
    'auth/user-not-found': 'There is no user record corresponding to this identifier.',
    'auth/wrong-password': 'The password is invalid for the given email.',
    'auth/invalid-email': 'The email address is badly formatted.',
    'auth/invalid-credential': "Invalid credentials, please try again."





    // Add more error codes and custom messages as needed
  };
  
  export default firebaseErrorMessages;
  